var _Glyphicon, _Glyphicon2;
import PropTypes from 'prop-types';
import React, { useRef, memo } from 'react';
import { useDevice } from '@atc/react-device';
import _get from 'lodash/get';
import { WalletPopover } from 'reaxl-wallet';
import { Button, DropdownButton, Glyphicon, MenuItem } from 'reaxl';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function FilteredResultsControls(_ref) {
  let {
    className,
    dropdownIconClassNames = 'sort-amount-up-alt-solid',
    dropdownLabel = 'Sort',
    enableWalletPopover,
    filterCount = 0,
    isStickyHeader,
    onFilterClick = () => {},
    onSortByChange = () => {},
    onWalletClick = () => {},
    optimizelyFilterText = 'Filter',
    optimizelyWalletText = 'My Wallet',
    paymentsDuck,
    renderCompareToggle,
    showCompare = false,
    showFilter = true,
    showWallet = false,
    sortData = {}
  } = _ref;
  const walletButtonRef = useRef(null);
  const showFilterCount = filterCount && filterCount > 0 ? ` (${filterCount})` : '';
  const device = useDevice();
  const isXs = _get(device, 'is.xs', false);
  const sortButton = /*#__PURE__*/_jsx(DropdownButton, {
    title: [/*#__PURE__*/_jsx(Glyphicon, {
      glyph: dropdownIconClassNames,
      className: "margin-right-2 text-accent"
    }, "sort-glyph"), dropdownLabel],
    id: isStickyHeader ? 'bg-nested-dropdown-sticky-header' : 'bg-nested-dropdown',
    onSelect: onSortByChange,
    children: Object.keys(sortData.options).reduce((acc, key) => {
      acc.push(/*#__PURE__*/_jsx(MenuItem, {
        disabled: sortData.options[key].disabled,
        active: sortData.value === sortData.options[key].value ? true : null,
        eventKey: sortData.options[key].value,
        children: sortData.options[key].label
      }, `menuItem-${key}`));
      return acc;
    }, [])
  }, "sort-dropdown");
  const compareButton = /*#__PURE__*/_jsx("div", {
    className: "btn-group btn-lean-toggle",
    children: renderCompareToggle
  }, "compareButton");
  const walletButton = /*#__PURE__*/_jsx("div", {
    className: "btn-group",
    ref: walletButtonRef,
    children: /*#__PURE__*/_jsxs(Button, {
      onClick: onWalletClick,
      "data-cmp": "mobileWalletButton",
      children: [_Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
        glyph: "wallet",
        className: "margin-right-2 text-accent"
      }, "wallet-glyph")), optimizelyWalletText]
    }, "walletButton")
  }, "walletButtonGroup");
  const mobileFilter = /*#__PURE__*/_jsxs(Button, {
    onClick: onFilterClick,
    "data-cmp": "mobileFilterButton",
    children: [_Glyphicon2 || (_Glyphicon2 = /*#__PURE__*/_jsx(Glyphicon, {
      glyph: "filter",
      className: "margin-right-2 text-accent"
    }, "filter-glyph")), optimizelyFilterText, showFilterCount]
  }, "mobileFilterButton");
  return /*#__PURE__*/_jsxs("div", {
    "data-cmp": "filteredResultsControls",
    className: className,
    children: [/*#__PURE__*/_jsxs("div", {
      className: "btn-group-lean button-wrapper btn-fill-space",
      children: [showFilter && isXs && mobileFilter, sortButton, showWallet && walletButton, showCompare && !isXs && compareButton]
    }), showWallet && /*#__PURE__*/_jsx(WalletPopover, {
      ref: walletButtonRef,
      paymentsDuck: paymentsDuck,
      withPopover: enableWalletPopover
    }, "walletPopover")]
  });
}
export default /*#__PURE__*/memo(FilteredResultsControls);